module.exports = __webpack_public_path__ + "media/sub2-6-1.5c1b3cbb.mp4";